import script from "./ruleDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ruleDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ruleDialog.vue?vue&type=style&index=0&id=7403b175&lang=scss"

const __exports__ = script;

export default __exports__